import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";

export const Right = styled.div`
    flex-grow: 0;
    display: flex;
    align-items: center;
    margin-left: 10px;
`;

export const FiltersContainer = styled.div`
    padding: 10px;
    height: 32px;
    display: flex;
    column-gap: 16px;
    align-items: center;
`;

export const BooleanSearchContainer = styled.div`
    width: 100%;
    padding-left: 15px;
`;

export const SearchContainer = styled.div`
    display: flex;
    align-items: center;
    border-top: 1px solid ${colorsPalettes.carbon[100]};
    padding: 8px 16px 8px 0;
    height: auto;
    .SearchInput-container {
        flex-grow: 1;
    }
    .SearchInput-container .SearchInput {
        height: 34px;
        background-color: ${colorsPalettes.carbon[0]};
        border: none;
        width: 100%;
        box-sizing: border-box;
        padding: 9px 2px 5px 50px;
        box-shadow: none;
        margin-bottom: 0px;
        &:focus {
            box-shadow: none !important;
            border: none;
        }
    }
`;
